export const campaignIds = {
  "august-urgency-messaging": "august-urgency-messaging"
}
